import React from 'react';
import Counter from '../Counter';
import {Box, Boxes, Details, Subtitle, Title} from './styled';

type ConfirmCounterProps = {
  title?: string;
  subtitle?: string;
  disabled?: boolean;
  value: number;
  onChange: (value: number) => void;
  error?: string;
};
const CounterStepper = React.forwardRef(
  ({title, subtitle, value, onChange, error, disabled}: ConfirmCounterProps, _) => {
    return (
      <Box>
        <Details>
          {Boolean(title) && <Title>{title}</Title>}
          <Subtitle>{subtitle}</Subtitle>
        </Details>
        <Boxes>
          <Counter
            value={value}
            onIncrement={() => {
              const checkedValue = value ?? 0;

              onChange(checkedValue + 1);
            }}
            onDecrement={() => {
              const checkedValue = value ?? 0;
              if (checkedValue < 1) return;
              onChange(checkedValue - 1);
            }}
            disabled={disabled}
            error={error}
          />
        </Boxes>
      </Box>
    );
  },
);

export {CounterStepper};
